import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";

interface QueryParams {
  hdb_ref: string;
  singpass_token: string;
  uinfin: string;
}

export const mamsApi = createApi({
  reducerPath: "mamsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getMamsEligibility: builder.query<boolean, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/mams/eligibility?hdb_ref=${queryParams.hdb_ref}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
          uinfin: queryParams.uinfin,
        },
      }),
      keepUnusedDataFor: 1,
    }),
  }),
});

export const { useGetMamsEligibilityQuery } = mamsApi;
